import React from "react";
import loadingSpinnerStyles from './LoadingSpinner.module.css'

export default function LoadingSpinner() {
    return (
        <div className={loadingSpinnerStyles.spinnerContainer}>
            <div className={loadingSpinnerStyles.loadingSpinner}></div>
        </div>
    );
}